import { render, staticRenderFns } from "./newpassword.vue?vue&type=template&id=659b1f6c&"
import script from "./newpassword.vue?vue&type=script&lang=js&"
export * from "./newpassword.vue?vue&type=script&lang=js&"
import style0 from "./newpassword.vue?vue&type=style&index=0&id=659b1f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports